export enum CookieBannerButtonType {
  declineButton = 'decline-button',
  acceptButton = 'accept-button' 
}